import { gsap } from 'gsap';
import Menu from './Menu';


export default class HomeFooter {
	constructor(elm, home) {

		this.home = home.container.querySelector('[data-home]');
		this.footer = elm;
        this.overlay = home.container.querySelector('[data-home-footer-overlay]');

        this.resizeObserver = new ResizeObserver(entries => {
			this.calculateTopPartHeight();
		});
		this.resizeObserver.observe(this.home);
        this.calculateTopPartHeight();

		this.setupScrolling();

        this.nav = elm.querySelector('[data-nav]');
        this.menu = new Menu(this.nav);
    }

	setupScrolling() {
		gsap.to(this.overlay, {
			opacity: 1,
			scrollTrigger: {
				trigger: this.footer,
				start: 'top bottom',
                end: 'top top',
				scrub: 0.5,
			},
			onStart: () => {
				document.dispatchEvent(new CustomEvent('hide-header'));
			},
			onReverseComplete: () => {
				document.dispatchEvent(new CustomEvent('show-header'));
			}
		});
	}

    calculateTopPartHeight() {
		this.home.style.setProperty(
			'--sticky-top',
			(this.home.clientHeight - document.documentElement.clientHeight) * -1 + 'px'
		);
	}

    destroy() {
        this.resizeObserver.disconnect();
	}

}
